import { FilterPanelSkeleton } from 'admin/src/components/ui/DataGrid/filters/FilterPanelSkeleton';
import type { FilterOperator } from 'admin/src/components/ui/DataGrid/filters/operators';
import type { FilterOption, FilterableColumn, NumberRange } from 'admin/src/components/ui/DataGrid/filters/types';
import { DateValue } from 'admin/src/components/ui/DataGrid/filters/values/DateValue';
import { NumberValue } from 'admin/src/components/ui/DataGrid/filters/values/NumberValue';
import { OptionValues } from 'admin/src/components/ui/DataGrid/filters/values/OptionValues';

export type FilterValuePanelProps = {
  column: FilterableColumn;
  operator: FilterOperator;
  values: string[];
  options: FilterOption[];
  numberRange?: NumberRange;
  dateRange?: { min: string; max: string };
  optionsReady: boolean;
  autoFocus?: boolean;
  showOperator?: boolean;
  onChange: (operator: FilterOperator, values: string[]) => void;
  onEmptyBackspace?: () => void;
};

export function FilterValuePanel({
  column,
  operator,
  values,
  options,
  numberRange,
  dateRange,
  optionsReady,
  autoFocus = true,
  showOperator = true,
  onChange,
  onEmptyBackspace,
}: FilterValuePanelProps) {
  const shared = { column, operator, values, autoFocus, onChange, onEmptyBackspace };

  if (column.dataType === 'number') return <NumberValue {...shared} range={numberRange} showOperator={showOperator} />;
  if (column.dataType === 'date') return <DateValue {...shared} range={dateRange} showOperator={showOperator} />;

  if (!optionsReady && !options.length) return <FilterPanelSkeleton />;

  return <OptionValues {...shared} options={options} />;
}
